import Tools from "./tools";

export type CheckoutGate = {
  blocked: boolean;
  closed: boolean;
  belowMinimum: boolean;
  minimumOrder: number;
  minOrderMessage: string;
  hoursMessage: any;
  blockReason: string;
};

export function getCheckoutGate({
  subtotal,
  minimumOrder = 0,
  timeBannerMessage,
}: {
  subtotal: number;
  minimumOrder?: number;
  timeBannerMessage?: any;
}): CheckoutGate {
  const belowMinimum = minimumOrder > 0 && subtotal < minimumOrder;
  const closed = !!timeBannerMessage;
  const minOrderMessage = belowMinimum
    ? `Minimum order is ${Tools.toCurrency(minimumOrder)}. Add ${Tools.toCurrency(
        minimumOrder - subtotal,
      )} more to checkout.`
    : "";
  const blockReason = closed
    ? "Ordering is not available at this time."
    : belowMinimum
      ? `Order can't be below the minimum order amount of ${Tools.toCurrency(
          minimumOrder,
        )}.`
      : "";

  return {
    blocked: closed || belowMinimum,
    closed,
    belowMinimum,
    minimumOrder,
    minOrderMessage,
    hoursMessage: timeBannerMessage,
    blockReason,
  };
}
